export default __webpack_public_path__ + "static/media/mist.0d62f028.jpg";